import type { Hub } from "@sentry/types";

type InstanceOptions = { sample_rate?: number };

let createInstance: (options?: InstanceOptions) => Promise<Hub>;

if (typeof globalThis.__CLIENT__ !== "undefined" && globalThis.__CLIENT__) {
  createInstance = (options?: InstanceOptions) =>
    import("./sentry-browser").then(m =>
      m.createInstance(options)
    ) as Promise<Hub>;
} else {
  createInstance = (options?: InstanceOptions | undefined) =>
    import("./sentry-node").then(m => m.createInstance(options));
}

let sentry_no_sampling: Hub | undefined = undefined;
let sentry_with_sampling: Hub | undefined = undefined;

export const getSentryWithSampling = async (): Promise<Hub> => {
  if (!sentry_with_sampling) {
    sentry_with_sampling = await createInstance();
  }
  return sentry_with_sampling;
};

export const getSentryNoSampling = async (): Promise<Hub> => {
  if (!sentry_no_sampling) {
    sentry_no_sampling = await createInstance({ sample_rate: 100 });
  }
  return sentry_no_sampling;
};
